import React, { useState, useCallback, useRef, useEffect } from 'react';
import {useHistory} from 'react-router-dom';
import { inject } from 'mobx-react';
import {toast} from 'react-toastify';
import { ManageSongGrid } from './mng-song-grid';
import { MusicPlayer } from '../music-player';

const ManageSongs = ({songsStore, playlistStore}) => {
    const [songItems, setSongItems] = useState([]);
    const [currentSong, setCurrentSong] = useState(null);
    useEffect(() => {
        const fetchData = async () => {
            await songsStore.fetchItems();
            setSongItems(songsStore.items)
        }
        fetchData()
    }, []);

    return (
        <div>
            <div className="grid-x padding-top-1 padding-left-1">
                <div className="cell auto">
                    <h3 data-ta="mngSongsHeader">Songs</h3>
                </div>
		    </div>
            <ManageSongGrid dataSource={songItems} onRowClick={(rowData) => {
                // playlistStore.setCurrentPlaylist({list: [rowData], name: '', imagePath:''});
                setCurrentSong(rowData);
            }} />
            <MusicPlayer currentSong={currentSong} />
        </div>
    )
}

const injectWithStores = inject('songsStore', 'playlistStore');

export default injectWithStores(
    ({songsStore, playlistStore}) => {
      
        return (
            <ManageSongs songsStore={songsStore} playlistStore={playlistStore}/>
        )
    })